import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ 
  text = 'Processing...', 
  spinnerColor = '#4ade80',
  backgroundColor = 'rgba(255, 255, 255, 0.95)'
}) => {
  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: backgroundColor,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10,
    }}>
      <div style={{
        width: '60px',
        height: '60px',
        border: '4px solid #e5e7eb',
        borderTop: `4px solid ${spinnerColor}`,
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      
      <p style={{
        marginTop: '24px',
        fontSize: '16px',
        color: '#374151',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        fontWeight: '400',
      }}>
        {text}
      </p>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

Spinner.propTypes = {
  text: PropTypes.string,
  spinnerColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default Spinner;